import { render, staticRenderFns } from "./ProjectCollapse.vue?vue&type=template&id=07c4713a"
import script from "./ProjectCollapse.vue?vue&type=script&lang=ts"
export * from "./ProjectCollapse.vue?vue&type=script&lang=ts"
import style0 from "./ProjectCollapse.vue?vue&type=style&index=0&id=07c4713a&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07c4713a')) {
      api.createRecord('07c4713a', component.options)
    } else {
      api.reload('07c4713a', component.options)
    }
    module.hot.accept("./ProjectCollapse.vue?vue&type=template&id=07c4713a", function () {
      api.rerender('07c4713a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/new/scheduler/ProjectCollapse.vue"
export default component.exports